import React from 'react';
import { observer } from '../../shared/observer';
import { curFormat } from '../../shared/format';

// Плашка «Бесплатная доставка» в корзине (№367) — как в приложении: кольцо с подарком
// набирается по мере наполнения корзины, рядом две строки. Порог и остаток считает
// сервер (cart.free_delivery); порога у компании нет — приходит null и блока нет.

const RING = 44;
const STROKE = 4;
const R = (RING - STROKE) / 2;
const C = 2 * Math.PI * R;

const GiftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 10h16v10H4zM3 7h18v3H3zM12 7v13" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M12 7c-1-3-5-3.5-5-1.5S10 7 12 7zm0 0c1-3 5-3.5 5-1.5S14 7 12 7z" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

// доля набранного порога: у «выполнен любой» ведущим считается тот, что ближе к цели
export const freeDeliveryView = (fd) => {
  if (!fd) return null;
  const byCount = fd.by === 'count';
  const need = byCount ? fd.need_count : fd.need_sum;
  const have = byCount ? fd.have_count : fd.have_sum;
  const fraction = fd.qualified ? 1 : need > 0 ? Math.min(have / need, 1) : 0;
  return { byCount, fraction };
};

class FreeDeliveryNoteView extends React.Component {
  render() {
    const fd = this.props.cart.cart.free_delivery;
    const view = freeDeliveryView(fd);
    if (!view) return null;

    const info = this.props.auth.companyInfo || {};
    const cur = (info.currency_hash && info.currency_hash.symbol_html) || '';
    const type = fd.type_title ? ' · ' + fd.type_title : '';
    const left = view.byCount
      ? `${fd.left_count} шт`
      : `${curFormat(fd.left_sum)} ${cur}`;
    const rule = view.byCount
      ? `от ${fd.need_count} шт${type}`
      : `от ${curFormat(fd.need_sum)} ${cur}`;
    const c = RING / 2;

    return (
      <div className={'ng-free-delivery' + (fd.qualified ? ' is-done' : '')}>
        <span className="ng-free-delivery__ring">
          <svg width={RING} height={RING} aria-hidden="true">
            <circle className="ng-free-delivery__track" cx={c} cy={c} r={R} strokeWidth={STROKE} />
            <circle
              className="ng-free-delivery__fill"
              cx={c}
              cy={c}
              r={R}
              strokeWidth={STROKE}
              strokeDasharray={C}
              strokeDashoffset={C * (1 - view.fraction)}
              transform={`rotate(-90 ${c} ${c})`}
            />
          </svg>
          <span className="ng-free-delivery__icon"><GiftIcon /></span>
        </span>
        <span className="ng-free-delivery__text">
          <strong className="ng-free-delivery__title">
            {fd.qualified ? 'Доставка бесплатно' : 'До бесплатной доставки'}
          </strong>
          <span className="ng-free-delivery__sub">
            {fd.qualified ? rule : [<b key="left">{'ещё ' + left}</b>, view.byCount ? type : '']}
          </span>
        </span>
      </div>
    );
  }
}

export const FreeDeliveryNote = observer(FreeDeliveryNoteView, ['cartStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/FreeDeliveryNote.jsx